import React, {useState} from 'react'
import {Avatar, Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import {RootState} from '../../../store'
import Actions from './Actions'
import Label from '../../customTable/Label'
import FixedNumber from '../../customTable/FixedNumber'
import Image from '../../customTable/Image'
import BasicMenu from './Discount'

export default function Row({item, order}: any) {
  const [editItem, setEditItem] = useState(item)

  const store = useSelector((state: RootState) => state.vender)
  const {t} = useTranslation()
  return (
    <>
      <tr className='fw-bold text-muted '>
        <td>
          <Stack gap='15px' direction={'row'}>
            <Stack width={'50px'} borderRadius={'8px'} height={'50px'}>
              <Image
                sx={{width: '100%', height: '100%', borderRadius: '8px'}}
                src={editItem.product && editItem.product.image}
                alt=''
              />
            </Stack>
            <Stack gap='8px'>
              <Typography sx={{fontSize: '14px', fontWeight: '500', color: '#7E8299'}}>
                {item.product &&
                  item.product.name &&
                  (item.product.name[store.lang] || item.product.name[store.defLang])}
              </Typography>
              {item.product &&
                item.product.order_options &&
                item.product.order_options.map((e: any, i: any) => (
                  <Stack direction={'row'} gap='5px' alignItems={'center'}>
                    <Typography key={i} sx={{color: 'var(--bs-body-color)'}}>
                      {e.name && (e.name[store.lang] || e.name[store.defLang])}{' '}
                    </Typography>
                    :{' '}
                    <Typography style={{color: 'var(--bs-text-gray-700)'}}>
                      {
                        e.value &&
                        (e.value[store.lang] || e.value[store.defLang]).includes('https://') ? (
                          <a
                            style={{color: '#03a9f4'}}
                            target={'_blank'}
                            href={e.value}
                            rel='noreferrer'
                          >
                            {' '}
                            {t('link')}{' '}
                          </a>
                        ) : (
                          e.value && (e.value[store.lang] || e.value[store.defLang])
                        )
                        //  &&
                        // (e.option_value[store.lang] || e.option_value[store.defLang])
                      }
                    </Typography>
                  </Stack>
                ))}
            </Stack>
          </Stack>
        </td>
        <td style={{textAlign: store.isRtl === 0 ? 'start' : 'start'}}>
          <span className='text-muted me-2 fs-7 fw-semibold'>{editItem.model}</span>
        </td>
        <td style={{textAlign: store.isRtl === 0 ? 'start' : 'start'}}>
          <span className='text-muted me-2 fs-7 fw-semibold'>{editItem.quantity}</span>
        </td>
        <td style={{textAlign: store.isRtl === 0 ? 'start' : 'start'}}>
          {' '}
          <Stack
            className='text-muted me-2 fs-7 fw-semibold'
            height={'100%'}
            justifyContent={'center'}
          >
            <FixedNumber num={editItem.unit_price} />{' '}
          </Stack>
        </td>

        <td style={{textAlign: store.isRtl === 0 ? 'start' : 'start'}}>
          <Stack
            className='text-muted me-2 fs-7 fw-semibold'
            height={'100%'}
            justifyContent={'center'}
          >
            <FixedNumber num={editItem.sub_total} />
          </Stack>
        </td>
        <td
          style={{
            textAlign: store.isRtl === 0 ? 'start' : 'start',
          }}
        >
          <Stack
            className='text-muted me-2 fs-7 fw-semibold'
            height={'100%'}
            // justifyContent={'center'}
            direction={'row'}
            gap='10px'
          >
            <FixedNumber num={editItem.total} />
            <BasicMenu editItem={editItem} />
          </Stack>
        </td>
      </tr>
      <tr style={{borderBottom: '1px solid #ff000000'}}>
        {editItem.refund_data && editItem.refund_data.reason && (
          <td colSpan={7}>
            <Stack
              p='8px !important'
              bgcolor={'rgba(113, 204, 255, 0.1) !important'}
              borderRadius={'8px'}
            >
              <Label fs='12px' fw='600' text='refundReason' />
              <Label
                fs='12px'
                color='#7D8192'
                text={editItem.refund_data && editItem.refund_data.reason}
              />
              {editItem.refund_data &&
                editItem.refund_data.refund_amount &&
                editItem.refund_data.refund_amount && (
                  <Stack gap='5px' direction={'row'} alignItems={'center'}>
                    <Label fw='600' fs='12px' text='refundAmount' />:
                    <FixedNumber
                      color='#7D8192'
                      fs='12px'
                      num={
                        editItem.refund_data &&
                        editItem.refund_data.refund_amount &&
                        editItem.refund_data.refund_amount
                      }
                    />
                  </Stack>
                )}
            </Stack>
          </td>
        )}
      </tr>
      <tr>
        {editItem.refund_data && editItem.refund_data.reject_reason && (
          <td colSpan={7}>
            <Stack
              p='8px !important'
              bgcolor={'rgba(113, 204, 255, 0.1) !important'}
              borderRadius={'8px'}
            >
              <Label fs='12px' fw='600' text='rejectReason' />
              <Label
                fs='12px'
                color='#7D8192'
                text={editItem.refund_data && editItem.refund_data.reject_reason}
              />
            </Stack>
          </td>
        )}
      </tr>
    </>
  )
}
